import React from 'react';
import { Button, Col, Row } from 'antd';
import Log from '../../../components/Log';

const LogsView = ({
  logs,
  setState,
  getNoLogImg,
  selectLog,
  openGallery,
  editLog,
  deleteLog,
  pageInfo,
  t,
  numberLogs,
  styles,
  state
}) => (
  <div style={{ margin: '0 auto', maxWidth: 1000 }}>
    {logs.length == 0 && (
      <div style={{ marginTop: '10%' }}>
        <img
          style={{ display: 'block', margin: '0 auto' }}
          src={getNoLogImg()}
        />
        <h1 className="noAvenir" style={styles.welcome}>
          {t('Welcome! Ready to start logging skills?')}
        </h1>
        <Button
          onClick={() => setState({ addLogModal: true })}
          style={styles.startButton}>
          {t("Let's get started!")}
        </Button>
      </div>
    )}
    <Row>
      {logs.length > 0 &&
        logs
          .slice(state.logsDisplayedFrom, state.logsDisplayedFrom + 10)
          .map((log, index) => (
            <Col
              xs={12}
              style={{
                padding: 10,
                opacity: state.exportMode
                  ? state.selectedLogs.includes(index)
                    ? 1
                    : 0.6
                  : 1
              }}
              onClick={() => state.exportMode && selectLog(index)}
              onMouseEnter={() =>
                !state.exportMode && setState({ hoverOn: index })
              }
              onMouseLeave={() =>
                !state.exportMode && setState({ hoverOn: null })
              }>
              <Log
                t={t}
                data={log}
                color={state.color}
                editButtons={state.hoverOn == index && true}
                openGallery={() =>
                  !state.exportMode &&
                  openGallery(state.logsDisplayedFrom + index)
                }
                deleteLog={() => deleteLog(log)}
                editLog={() => editLog(log)}
              />
            </Col>
          ))}
      {logs.length > 20 && (
        <Col
          xs={24}
          style={{
            display: 'inline-flex',
            justifyContent: 'space-between',
            padding: '10px 10px 20px 10px'
          }}>
          <Button
            className={state.logsDisplayedFrom < 9 && 'hidden'}
            style={styles.button}
            onClick={() =>
              setState({ logsDisplayedFrom: state.logsDisplayedFrom - 10 })
            }>
            {t('Previous')}
          </Button>
          <div style={styles.pageNum}>{pageInfo(logs)}</div>
          <Button
            className={state.logsDisplayedFrom + 10 > numberLogs && 'hidden'}
            style={styles.button}
            onClick={() =>
              setState({ logsDisplayedFrom: state.logsDisplayedFrom + 10 })
            }>
            {t('Next')}
          </Button>
        </Col>
      )}
    </Row>
  </div>
);

export default LogsView;



// WEBPACK FOOTER //
// ./src/containers/StudentApp/components/logsView.js